<template>
  <v-container
    fluid
    class="ac2-page">
    <v-card class="rounded-lg table-card pa-4">
      <v-data-table
        :headers="header"
        :items="items"
        :loading="loading"
        :items-per-page="-1"
        hide-default-footer
        class="w-full"
      >
        <template v-slot:top>
          <div class="d-flex align-center flex-wrap px-4 pt-4 pb-2">
            <div>
              <h6 class="text-h6 mb-0">
                Document Lead time
              </h6>
            </div>
            <v-spacer />
            <v-select
              v-model="selectedStore"
              :items="storeOptions"
              item-text="name"
              item-value="id"
              color="secondary"
              class="flex-grow-0"
              style="max-width: 220px;"
              outlined
              dense
              hide-details
              @change="getData()" />
          </div>
          <v-divider />
        </template>

        <template #[`item.channel`]="{ item }">
          <span class="text-bold">{{ formatChannel(item.channel) }}</span>
        </template>

        <template #[`item.document`]="{ item }">
          {{ formatDocument(item.document) }}
        </template>

        <template #[`item.stockAction`]="{ item }">
          <v-chip
            small
            :color="item.stockAction === 'INBOUND' ? 'blue lighten-4' : 'orange lighten-4'"
            :text-color="item.stockAction === 'INBOUND' ? 'blue darken-2' : 'orange darken-3'">
            {{ item.stockAction }}
          </v-chip>
        </template>

        <template #[`item.rule`]="{ item }">
          <div class="py-1">
            <div>{{ describeRule(item) }}</div>
            <div class="text-caption grey--text">
              ส่งเวลา: {{ item.deliveryTime || 'เวลาที่สั่ง' }}
            </div>
          </div>
        </template>

        <template #[`item.option`]="{ item }">
          <v-btn
            link
            icon
            x-small
            title="แก้ไข"
            @click="editItem(item)">
            <v-icon>
              mdi-pencil-outline
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="showForm"
      persistent
      max-width="500px">
      <v-card>
        <v-card-title class="pb-1">
          <span class="text-h6 mb-2">ตั้งค่า Leadtime</span>
        </v-card-title>
        <v-card-subtitle class="pt-2">
          <div
            class="d-flex align-center flex-wrap"
            style="gap: 6px;">
            <v-chip
              small
              label
              color="secondary"
              outlined>
              {{ formatDocument(formData.document) }}
            </v-chip>
            <v-chip
              small
              label
              color="secondary">
              {{ formatChannel(formData.channel) }}
            </v-chip>
            <v-chip
              small
              label
              :color="formData.stockAction === 'INBOUND' ? 'blue lighten-4' : 'orange lighten-4'"
              :text-color="formData.stockAction === 'INBOUND' ? 'blue darken-2' : 'orange darken-3'">
              {{ formData.stockAction }}
            </v-chip>
          </div>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="pt-4">
          <v-form
            ref="ac2-document-form"
            @submit.prevent="onSubmit()">
            <!-- มีเวลาcutoff? -->
            <div class="form-row">
              <div class="form-label">
                มีเวลา cutoff
              </div>
              <div class="form-control">
                <v-radio-group
                  v-model="useCutoff"
                  class="mt-0"
                  row
                  hide-details
                  dense
                  @change="onToggleCutoff">
                  <v-radio
                    color="secondary"
                    :value="false">
                    <template #label>
                      <span class="text-body-2">ไม่มี</span>
                    </template>
                  </v-radio>
                  <v-radio
                    color="secondary"
                    :value="true">
                    <template #label>
                      <span class="text-body-2">มี</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
            </div>

            <!-- โหมดไม่มี cutoff -->
            <div
              v-if="!useCutoff"
              class="form-row">
              <div class="form-label">
                เสร็จภายใน
              </div>
              <div class="form-control">
                <v-text-field
                  v-model.number="formData.deliveryDayBeforeCutoff"
                  :rules="daysRules"
                  type="number"
                  min="1"
                  suffix="วัน"
                  class="field-box"
                  color="secondary"
                  outlined
                  dense
                  hint="1 = วันนี้, 2 = พรุ่งนี้"
                  persistent-hint />
              </div>
            </div>

            <!-- โหมดมี cutoff -->
            <template v-else>
              <div class="form-row">
                <div class="form-label">
                  เวลา cutoff
                </div>
                <div class="form-control">
                  <v-text-field
                    v-model="formData.cutoffTime"
                    :rules="cutoffRules"
                    type="time"
                    class="field-box"
                    color="secondary"
                    outlined
                    dense
                    hide-details />
                </div>
              </div>
              <div class="form-row">
                <div class="form-label">
                  สั่ง <b>ก่อน</b> cutoff เสร็จถายใน
                </div>
                <div class="form-control">
                  <v-text-field
                    v-model.number="formData.deliveryDayBeforeCutoff"
                    :rules="daysRules"
                    type="number"
                    min="1"
                    suffix="วัน"
                    class="field-box"
                    color="secondary"
                    outlined
                    dense
                    hint="1 = วันนี้, 2 = พรุ่งนี้"
                    persistent-hint />
                </div>
              </div>
              <div class="form-row">
                <div class="form-label">
                  สั่ง <b>หลัง</b> cutoff เสร็จถายใน
                </div>
                <div class="form-control">
                  <v-text-field
                    v-model.number="formData.deliveryDayAfterCutoff"
                    :rules="daysRules"
                    type="number"
                    min="1"
                    suffix="วัน"
                    class="field-box"
                    color="secondary"
                    outlined
                    dense
                    hint="1 = วันนี้, 2 = พรุ่งนี้"
                    persistent-hint />
                </div>
              </div>
            </template>

            <!-- เวลาจบงาน (ทั้งสองโหมด) -->
            <div class="form-row">
              <div class="form-label">
                เวลาจบงาน
                <span class="text-caption grey--text ml-3">เว้นว่าง = เวลาที่สั่ง</span>
              </div>
              <div class="form-control d-flex align-center">
                <v-text-field
                  v-model="formData.deliveryTime"
                  type="time"
                  placeholder="HH:mm"
                  class="field-box"
                  color="secondary"
                  outlined
                  dense
                  clearable
                  hide-details />
              </div>
            </div>

            <v-divider class="my-4" />

            <!-- Live example -->
            <v-alert
              dense
              text
              border="left"
              color="secondary"
              class="example-alert mt-5 mb-0">
              <div class="text-caption font-weight-bold mb-1">
                <v-icon
                  x-small
                  color="secondary"
                  class="mr-1">
                  mdi-lightbulb-on-outline
                </v-icon>
                ตัวอย่าง — ถ้าสร้างเอกสารตอนนี้
              </div>
              <div class="text-body-2">
                <p class="mb-0">
                  สร้าง {{ example.now }}
                </p>
                <p class="mb-0">
                  จบงานภายใน <b>{{ example.target }}</b>
                </p>
              </div>
            </v-alert>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            :disabled="saving"
            @click="closeForm()">
            CANCEL
          </v-btn>
          <v-btn
            color="secondary"
            depressed
            :loading="saving"
            @click="onSubmit()">
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import { GentlewomanStore } from '@/assets/js/Constant'
import Ac2DocumentConfigProvider from '@/resources/Ac2DocumentConfigProvider'

const Ac2DocumentConfigService = new Ac2DocumentConfigProvider()

export default {
  data () {
    return {
      loading: false,
      saving: false,
      showForm: false,
      useCutoff: false,
      selectedStore: GentlewomanStore.id,
      storeOptions: [
        {
          id: '5e3548c2d32cb12606a34fb8',
          name: 'Gentlewoman'
        },
        {
          id: '645a1d00765d5519beeb97f6',
          name: 'Matter Makers'
        }
      ],
      daysRules: [
        (v) => (v !== '' && v !== null && v !== undefined) || 'กรุณากรอกจำนวนวัน',
        (v) => Number.isInteger(Number(v)) || 'ต้องเป็นจำนวนเต็ม',
        (v) => Number(v) >= 1 || 'ต้องมากกว่าหรือเท่ากับ 1'
      ],
      cutoffRules: [
        (v) => !!v || 'กรุณาระบุเวลาcutoff'
      ],
      formData: {
        id: null,
        document: '',
        channel: '',
        stockAction: '',
        deliveryDayBeforeCutoff: 2,
        deliveryDayAfterCutoff: 2,
        cutoffTime: null,
        deliveryTime: null
      },
      header: [
        { text: 'CHANNEL', value: 'channel', sortable: false },
        { text: 'Doc', value: 'document', sortable: false },
        { text: 'STOCK ACTION', value: 'stockAction', sortable: false },
        { text: 'Lead time', value: 'rule', sortable: false },
        {
          text: 'Actions',
          value: 'option',
          align: 'center',
          sortable: false,
          width: '90px'
        }
      ],
      items: []
    }
  },
  computed: {
    example () {
      const before = Number(this.formData.deliveryDayBeforeCutoff) || 1
      const after = Number(this.formData.deliveryDayAfterCutoff) || 1
      const now = dayjs()

      let days = before

      if (this.useCutoff && this.formData.cutoffTime) {
        const [h, m] = this.formData.cutoffTime.split(':').map(Number)
        const cutoffToday = now.hour(h).minute(m).second(0).millisecond(0)
        const isAfter = now.isAfter(cutoffToday)
        days = isAfter ? after : before
      }

      let target = now.add(days - 1, 'day')
      if (this.formData.deliveryTime) {
        const [dh, dm] = this.formData.deliveryTime.split(':').map(Number)
        target = target.hour(dh).minute(dm).second(0).millisecond(0)
      }

      return {
        now: now.format('DD/MM/YYYY HH:mm'),
        target: target.format('DD/MM/YYYY HH:mm')
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar'
    }),
    formatChannel (channel) {
      return channel ? String(channel).toUpperCase() : '-'
    },
    formatDocument (document) {
      return document ? String(document).replace(/_/g, ' ') : '-'
    },
    onToggleCutoff () {
      // สลับโหมด มี/ไม่มี cutoff → ล้างค่าเริ่มใหม่
      this.formData.cutoffTime = this.useCutoff ? '12:00' : null
      this.formData.deliveryTime = null
      this.formData.deliveryDayBeforeCutoff = this.useCutoff ? 1 : 2
      this.formData.deliveryDayAfterCutoff = 2
      if (this.$refs['ac2-document-form']) {
        this.$refs['ac2-document-form'].resetValidation()
      }
    },
    describeRule (item) {
      if (item.cutoffTime) {
        return `ภายใน ${item.cutoffTime}: จบงานใน ${item.deliveryDayBeforeCutoff
        ? `${item.deliveryDayBeforeCutoff} วัน`
        : 'วันสร้างเอกสาร'} · หลัง: จบงานใน ${item.deliveryDayAfterCutoff} วัน`
      }
      return `${item.deliveryDayBeforeCutoff} วัน`
    },
    async getData () {
      try {
        this.loading = true
        const { data } = await Ac2DocumentConfigService.getDocumentConfigs({
          store: this.selectedStore
        })
        this.items = data
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `Error ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    editItem (item) {
      this.useCutoff = !!item.cutoffTime
      this.formData = {
        id: item.id,
        document: item.document,
        channel: item.channel,
        stockAction: item.stockAction,
        deliveryDayBeforeCutoff: item.deliveryDayBeforeCutoff,
        deliveryDayAfterCutoff: item.deliveryDayAfterCutoff,
        cutoffTime: item.cutoffTime || null,
        deliveryTime: item.deliveryTime || null
      }
      this.showForm = true
    },
    closeForm () {
      this.showForm = false
      if (this.$refs['ac2-document-form']) {
        this.$refs['ac2-document-form'].resetValidation()
      }
    },
    async onSubmit () {
      const valid = this.$refs['ac2-document-form'].validate()
      if (!valid) return

      const before = Number(this.formData.deliveryDayBeforeCutoff)
      const after = Number(this.formData.deliveryDayAfterCutoff)

      try {
        this.saving = true
        await Ac2DocumentConfigService.updateDocumentConfigById(this.formData.id, {
          deliveryDayBeforeCutoff: before,
          // ไม่มีเวลาcutoff → บวกวันเท่ากันทุกกรณี (backend ใช้ค่า before)
          deliveryDayAfterCutoff: this.useCutoff ? after : before,
          cutoffTime: this.useCutoff ? (this.formData.cutoffTime || null) : null,
          deliveryTime: this.formData.deliveryTime || null
        })

        this.setSnackbar({
          value: true,
          message: 'แก้ไข config สำเร็จ',
          type: 'success'
        })

        this.closeForm()
        this.getData()
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `Error ${error.message}`,
          type: 'error'
        })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
<style scoped>
.table-card {
  min-height: calc(100vh - 96px);
}
.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}
.form-row:last-child {
  margin-bottom: 0;
}
.form-label {
  flex: 1 1 auto;
  padding-top: 10px;
  padding-right: 16px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.72);
}
.theme--dark .form-label {
  color: rgba(255, 255, 255, 0.72);
}
.form-control {
  flex: 0 0 auto;
  text-align: right;
}
.field-box {
  width: 140px;
}
.example-alert {
  border-radius: 8px;
}
</style>
